import { defineStore } from 'pinia'
// import SecureLS from "secure-ls";
// const ls = new SecureLS({ isCompression: false });

export const useGeneralStore = defineStore('general', {
  state: () => ({
    generalSettings: {
      about: '',
      termsConditions: '',
      privacyPolicy: ''
    },
    categories: [],
    prayers: [],
    music: [],
    katisashi: [],
    evangelio: [],
    events: [],
    loading: true
  }),

  getters: {
    getGeneralSettings: state => state.generalSettings, 
    getCategories: state => state.categories,
    getPrayers: state => state.prayers,
    getMusic: state => state.music,
    getEvents: state => state.events,
    getKatisashis: state => state.katisashi,
    getEvangelio: state => state.evangelio,
    getLoading: state => state.loading
  },

  actions: {
    setGeneralSettings(payload) {
      this.generalSettings = payload;
    },

    loadCategories(payload) {
      this.categories = payload;
    },

    setNewCategory(payload) {
      this.categories.unshift(payload);
    },

    editCategory(payload) {
      const categoryObjectIndex = this.categories.findIndex(category => category._id === payload._id);
      this.categories[categoryObjectIndex] = payload;
    },

    deleteCategory(payload) {
      const categoryObjectIndex = this.categories.findIndex(category => category._id === payload);
      this.categories.splice(categoryObjectIndex, 1);
    },

    loadPrayers(payload) {
      this.prayers = payload;
    },

    setNewPrayers(payload) {
      this.prayers.unshift(payload);
    },

    editPrayer(payload) {
      const prayerObjectIndex = this.prayers.findIndex(prayer => prayer._id === payload._id);
      this.prayers[prayerObjectIndex] = payload;
    },

    deletePrayer(payload) {
      const prayerObjectIndex = this.prayers.findIndex(prayer => prayer._id === payload);
      this.prayers.splice(prayerObjectIndex, 1)
    },

    loadEvents(payload) {
      this.events = payload;
    },
    setNewEvent(payload) {
      this.events.unshift(payload);
    },

    editEvent(payload) {
      const eventObjectIndex = this.events.findIndex(event => event._id === payload._id);
      this.events[eventObjectIndex] = payload;
    },

    deleteEvent(payload) {
      const eventObjectIndex = this.events.findIndex(event => event._id === payload);
      this.events.splice(eventObjectIndex, 1);
    },

    loadMusic(payload) {
      this.music = payload;
    },

    setNewMusic(payload) {
      this.music.unshift(payload);
    },

    editMusic(payload) {
      const musicObjectIndex = this.music.findIndex(music => music._id === payload._id);
      this.music[musicObjectIndex] = payload;
    },

    deleteMusic(payload) {
      const musicObjectIndex = this.music.findIndex(music => music._id === payload);
      this.music.splice(musicObjectIndex, 1);
    },

    loadKatisashis(payload) {
      this.katisashi = payload;
    },

    setNewKatisashi(payload) {
      this.katisashi.unshift(payload);
    },

    editKatisashi(payload) {
      const katisashiObjectIndex = this.katisashi.findIndex(katisashi => katisashi._id === payload._id);
      this.katisashi[katisashiObjectIndex] = payload;
    },

    deleteKatisashi(payload) {  
      const katisashiObjectIndex = this.katisashi.findIndex(katisashi => katisashi._id === payload);
      this.katisashi.splice(katisashiObjectIndex, 1);
    },

    loadEvangelio(payload) {
      this.evangelio = payload;
    },

    setNewEvangelio(payload) {
      this.evangelio.unshift(payload);
    },

    editEvangelio(payload) {
      const evangelioObjectIndex = this.evangelio.findIndex(evangelio => evangelio._id === payload._id);
      this.evangelio[evangelioObjectIndex] = payload;
    },

    deleteEvangelio(payload) {  
      const evangelioObjectIndex = this.evangelio.findIndex(evangelio => evangelio._id === payload);
      this.evangelio.splice(evangelioObjectIndex, 1);
    },

    setloading(payload) {
      this.loading = payload;
    }
  }
})